export function prettyError(error) {
  if (!error) return "Unknown error";

  if (typeof error === "string") return error;

  if (error?.data) {
    const data = error.data;

    if (typeof data.detail === "string") return data.detail;

    if (typeof data === "object") {
      const lines = [];

      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          lines.push(`${key}: ${value.join(", ")}`);
        } else if (typeof value === "string") {
          lines.push(`${key}: ${value}`);
        } else {
          lines.push(`${key}: ${JSON.stringify(value)}`);
        }
      });

      if (lines.length) return lines.join(" | ");
    }
  }

  return error.message || "Something went wrong";
}